import * as React from 'react';
import {
  Grid,
  TextField,
  Box,
} from '@material-ui/core';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import axios from 'axios';
import useSWR from 'swr';
import type { ICompany } from '../../../massReceive/MassReceiveInterfaces';
import { emptyCompany } from '../Utilities/PolicyConfiguratorHelpers';

interface ICompanyFilterProps {
  companyFormValue: ICompany | undefined,
  setCompanyFormValue: (values: ICompany) => void,
  companyRef?: React.RefObject<HTMLInputElement>;
}

const CompanyFilter: React.FC<ICompanyFilterProps> = ({
  companyFormValue,
  setCompanyFormValue,
  companyRef,
}) => {
  const fetcher = (url: string) => axios.get<ICompany[]>(url)
    .then((response) => [...response.data, { companyId: '', companyName: 'All Companies' }]);

  const { data } = useSWR('/massReceive/getCompanies', (url) => fetcher(url));

  return (
    <Grid item lg={4} md={6} xs={12}>
      <Box pl={1} py={1.5}>
        {!data
          ? <Skeleton variant="rect" height={79} />
          : (
            <Autocomplete
              value={data.find((d) => d.companyName === companyFormValue?.companyName) || { companyId: '', companyName: '' }}
              onChange={(event, selectedOption) => {
                if (selectedOption) {
                  setCompanyFormValue({ ...selectedOption });
                } else {
                  setCompanyFormValue({ ...emptyCompany() });
                }
              }}
              autoHighlight
              autoSelect
              options={data}
              getOptionLabel={(option) => option?.companyName?.toString()}
              renderInput={(params) => (
                <TextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  id="company-field-select"
                  inputRef={companyRef}
                  label="Company"
                  variant="outlined"
                  helperText="Select Company"
                />
              )}
            />
          )}
      </Box>
    </Grid>
  );
};

export default CompanyFilter;
